import type { ContractSchema } from '@libs/data-access/entities'
import { Modal, Stack, defineModal } from '@libs/ui/ds'
import { usePlanningTranslation } from '@libs/utils/translations'
import type { FC } from 'react'

import BirthdayMember from './components/BirthdayMember'

type BirthdayModalProps = {
  contracts: ContractSchema[]
  day: string
}

export const birthdayModalDef = defineModal<BirthdayModalProps>({
  name: 'birthdayModal'
})

const BirthdayModal: FC = () => {
  const { close, isOpen, data } = birthdayModalDef.useModal()
  const { t, tDates } = usePlanningTranslation()
  const date = data?.day

  return (
    <Modal opened={isOpen} onClose={close} variant='center' size='xs'>
      <Modal.Header
        title={t('common.titleBirthdayModal')}
        desc={tDates('dates.literalDate', { date })}
      />
      <Modal.Content>
        <Stack gap={3} col>
          {data?.contracts.map(contract => (
            <BirthdayMember contract={contract} key={contract.id} />
          ))}
        </Stack>
      </Modal.Content>
    </Modal>
  )
}

export default birthdayModalDef.withModalShow(BirthdayModal)
